<template>
  <div class="horizontal-radio">
    <v-radio-group v-model="selected">
      <v-radio
        class="text-primary"
        v-for="(option, key) in options"
        :key="key"
        :value="+key"
        :color="color"
        @change="handleChange"
      >
        <template #label>
          <span :class="`text-${color}`">{{ option }}</span>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: 'HorizontalCheckBoxes',

  props: {
    options: {
      required: true,
      type: Object,
    },
    value: {
      required: true,
      type: Number,
    },
    field: {
      required: true,
      type: String,
    },
    color: {
      type: String,
      default: '#3b587d',
    },
  },
  data() {
    return {
      selected: this.value,
    }
  },
  watch: {
    value(val) {
      this.selected = val
    },
  },
  methods: {
    handleChange(news) {
      this.$emit('change', news)
    },
  },
}
</script>

<style lang="scss">
.horizontal-radio {
  // margin-left: -4px;

  .v-input.v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;

    .v-radio > .v-label {
      line-height: 36px;
      font-size: 36px;
    }
  }
}
</style>
